// @flow

import Resource from 'speed-js-core/src/api/Resource';

class PointLayer14Resource extends Resource {
    forPoint(query: Object): Promise<Object> {
        return this.client._request(
            `${this.basePath}for_point/`,
            'GET', query,
        ).then((response) => response);
    }
}

export default PointLayer14Resource;
